import ReactModal from 'react-modal';
import { ReactComponent as DeleteIcon } from '../../../images/nde-icon-delete.svg';
import { useSelector } from 'react-redux';
import { selectControls } from '../../../redux/controls';
import './DeepLinkErrorModal.scss';

interface DeepLinkErrorModalProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

function DeepLinkErrorModal({
  open,
  message,
  onClose,
}: DeepLinkErrorModalProps): JSX.Element {
  const controls = useSelector(selectControls);
  ReactModal.setAppElement('#root');

  return (
    <>
      {open && (
        <ReactModal
          isOpen={open}
          className="nqt-modal nqt-deep-link-error-modal"
          overlayClassName="nqt-modal-overlay"
          shouldFocusAfterRender={true}
          shouldReturnFocusAfterClose={true}
          contentLabel="Deep Link Error"
        >
          <div className="nqt-modal--container">
            <div className="nqt-modal--header-group">
              <header className="nqt-modal--title">{controls?.DeepLnkErrDlgTitle?.controlText}</header>
              <button
                className="nqt-modal--close-button"
                type="button"
                onClick={onClose}
              >
                <DeleteIcon />
                <span className="visually-hidden">
                  {controls?.ModalClose?.controlText}
                </span>
              </button>
            </div>
            <div className="nqt-modal--border">
              <section className="nqt-modal--content nqt-deep-link-error-modal--content">
                <span className="nqt-modal--body">{message}</span>
              </section>
              <hr />
              <div className="nqt-deep-link-error-modal--buttons">
                <button
                  className="nqt-button--submit nqt-deep-link-error-modal--ok"
                  type="button"
                  onClick={onClose}
                >
                  {controls?.ModalOK?.controlText || 'OK'}
                </button>
              </div>
            </div>
          </div>
        </ReactModal>
      )}
    </>
  );
}

export default DeepLinkErrorModal;
